/**
 * Setup Scroll Animations
 *
 * Enqueued in the frontend + editor.
 *
 * @package pixelative-blocks
 * @version 0.1.0
 * @author Arslan Akram <arslan@pixelative.co>
 * @copyright 2023, Pixelative <pixelative.co>
 */

import LocomotiveScroll from 'locomotive-scroll';

// See if DOM is already available
function docReady(fn) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
docReady(function () {
  // Add Loaded Class to Body
  document.body.classList.add('page-loaded');

  // Intro Animations
  let logoEl = document.querySelectorAll('.site-branding img'),
    ToggleLineEl = document.querySelectorAll('.toggle-line'),
    setupIntroAnimations;

  // Intro Line, Logo & Toggle Animations
  setupIntroAnimations = function () {
    // Animate Logo First
    setTimeout(function () {
      logoEl.forEach(el => el.classList.add('logo-in'));
    }, 1000);

    // Then Toggle Lines
    setTimeout(function () {
      ToggleLineEl.forEach(el => el.classList.add('toggle-line-in'));
    }, 1500);
  };

  // Init Setup
  setupIntroAnimations();

  //! Init in _lazyload_images.js
  // Then Init Locomotive Scroll
  // setTimeout(function () {
  // 	var peScroll = new LocomotiveScroll({
  // 		el: document.querySelector('body'),
  // 		smooth: false,
  // 	});

  // 	window.peScroll = peScroll;
  // }, 0);
});

window.addEventListener('load', e => {});